import React, { useState, useEffect } from 'react';
import '../styles/PaceSettingsModal.css';

function PaceSettingsModal({ isOpen, onClose, paceSettings, onSave }) {
  const [localPaceSettings, setLocalPaceSettings] = useState(paceSettings);

  useEffect(() => {
    if (isOpen) {
      setLocalPaceSettings(paceSettings);
    }
  }, [isOpen, paceSettings]);

  const handlePaceChange = (field, value) => {
    setLocalPaceSettings(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = () => {
    onSave(localPaceSettings);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="pace-settings-modal-overlay" onClick={onClose}>
      <div className="pace-settings-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pace-settings-header">
          <h2 className="pace-settings-title">Pace Settings</h2>
          <button className="pace-settings-close" onClick={onClose}>×</button>
        </div>
        
        <div className="pace-settings-content">
          <p className="pace-settings-description">
            Set your personal pace for each activity. Used to estimate distance when Apple Health is not connected.
          </p>

          <div className="pace-settings-item">
            <label className="pace-settings-label">Run Pace</label>
            <div className="pace-settings-control" style={{ gap: '8px' }}>
              <input
                type="number"
                value={localPaceSettings.runPaceMinutes}
                onChange={(e) => handlePaceChange('runPaceMinutes', parseInt(e.target.value) || 0)}
                className="pace-settings-input"
                min="4"
                max="20"
                style={{ width: '70px' }}
              />
              <span>:</span>
              <input
                type="number"
                value={localPaceSettings.runPaceSeconds}
                onChange={(e) => handlePaceChange('runPaceSeconds', Math.min(59, parseInt(e.target.value) || 0))}
                className="pace-settings-input"
                min="0"
                max="59"
                style={{ width: '70px' }}
              />
              <span className="pace-settings-description-text">per mile</span>
            </div>
          </div>

          <div className="pace-settings-item">
            <label className="pace-settings-label">Bike Avg Speed</label>
            <div className="pace-settings-control">
              <input
                type="number"
                value={localPaceSettings.bikingAvgMph}
                onChange={(e) => handlePaceChange('bikingAvgMph', parseFloat(e.target.value) || 0)}
                className="pace-settings-input"
                min="5"
                max="40"
                step="0.5"
                style={{ width: '100px' }}
              />
              <span className="pace-settings-description-text">mph</span>
            </div>
          </div>

          <div className="pace-settings-item">
            <label className="pace-settings-label">Swim Pace</label>
            <div className="pace-settings-control" style={{ gap: '8px' }}>
              <input
                type="number"
                value={localPaceSettings.swimPaceMinutes}
                onChange={(e) => handlePaceChange('swimPaceMinutes', parseInt(e.target.value) || 0)}
                className="pace-settings-input"
                min="1"
                max="10"
                style={{ width: '70px' }}
              />
              <span>:</span>
              <input
                type="number"
                value={localPaceSettings.swimPaceSeconds}
                onChange={(e) => handlePaceChange('swimPaceSeconds', Math.min(59, parseInt(e.target.value) || 0))}
                className="pace-settings-input"
                min="0"
                max="59"
                style={{ width: '70px' }}
              />
              <span className="pace-settings-description-text">per 100 yards</span>
            </div>
          </div>

          <div className="pace-settings-item">
            <label className="pace-settings-label">Walk Pace</label>
            <div className="pace-settings-control">
              <input
                type="number"
                value={localPaceSettings.walkPaceMinutes}
                onChange={(e) => handlePaceChange('walkPaceMinutes', parseInt(e.target.value) || 0)}
                className="pace-settings-input"
                min="10"
                max="30"
                style={{ width: '100px' }}
              />
              <span className="pace-settings-description-text">min per mile</span>
            </div>
          </div>
        </div>

        <div className="pace-settings-actions">
          <button className="pace-settings-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="pace-settings-save" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default PaceSettingsModal;
